/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_Col_RegionInputs */

const en_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const de_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const fr_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Région`)
};

const es_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Región`)
};

const it_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regione`)
};

const nl_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regio`)
};

const pl_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const fi_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alue`)
};

const da_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const sv_salary_compare_col_region = /** @type {(inputs: Salary_Compare_Col_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

/**
* | output |
* | --- |
* | "Region" |
*
* @param {Salary_Compare_Col_RegionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_col_region = /** @type {((inputs?: Salary_Compare_Col_RegionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_Col_RegionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_col_region(inputs)
	if (locale === "fr") return fr_salary_compare_col_region(inputs)
	if (locale === "es") return es_salary_compare_col_region(inputs)
	if (locale === "it") return it_salary_compare_col_region(inputs)
	if (locale === "nl") return nl_salary_compare_col_region(inputs)
	if (locale === "pl") return pl_salary_compare_col_region(inputs)
	if (locale === "fi") return fi_salary_compare_col_region(inputs)
	if (locale === "da") return da_salary_compare_col_region(inputs)
	if (locale === "sv") return sv_salary_compare_col_region(inputs)
	return en_salary_compare_col_region(inputs)
});